// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1vrRc","ranges":"BmiRanges_ranges__3ZzrM"};